import React, { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import theme from 'theme';
import { IRecoveryPassword } from 'types/Auth';
import { passwordMatch } from 'util/auth';

import { Grid, Typography } from '@mui/material';

const mainColor = theme.palette.primary.main;

export const PasswordStrength: React.FC = () => {
  const { control } = useFormContext<IRecoveryPassword>();
  const password = useWatch({ control, name: 'password' });

  const {
    hasLowerCase,
    hasNumber,
    hasUpperCase,
    minLength,
    hasSpecialCharacter,
  } = useMemo(() => {
    return passwordMatch(password);
  }, [password]);

  return (
    <Grid item container mt={2}>
      <Grid item xs={12}>
        <Typography color={mainColor} fontSize={12} fontWeight={500}>
          A senha deve ter:
        </Typography>
      </Grid>

      <Grid item container xs={12}>
        <PasswordMatchRule valid={minLength}>
          No mínimo 8 caracteres
        </PasswordMatchRule>

        <PasswordMatchRule valid={hasNumber}>
          Pelo menos 1 número
        </PasswordMatchRule>

        <PasswordMatchRule valid={hasUpperCase}>
          Pelo menos 1 letra maiúscula
        </PasswordMatchRule>

        <PasswordMatchRule valid={hasLowerCase}>
          Pelo menos 1 letra minúscula
        </PasswordMatchRule>

        <PasswordMatchRule valid={hasSpecialCharacter}>
          Pelo menos 1 caractere especial
        </PasswordMatchRule>
      </Grid>
    </Grid>
  );
};

const PasswordMatchRule: React.FC<{ valid: boolean }> = ({
  children,
  valid,
}) => {
  return (
    <Grid item md={6} xs={12}>
      <Typography
        color={valid ? mainColor : '#B0B0B0'}
        fontWeight={500}
        fontSize={12}
      >
        • {children}
      </Typography>
    </Grid>
  );
};
